// extracted by mini-css-extract-plugin
export default {"CopyToClipboard":"nUNdd","CopyToClipboard--copied":"vBL9c"};